import React from "react";
import { useFetchFailures } from "src/queries/hooks/admin";
import { FIELDS } from "./Failures.consts";
import { Link, IconButton } from "@mui/material";
import ExternalIcon from "src/icons/ExternalIcon";
import { getLinkToAgent, capitalizeFirstLetter } from "@utils";

export default function useFailures() {
  const { data: failures, isLoading } = useFetchFailures();

  const linkRenderCell = (url) => {
    if (!url) return null;
    return (
      <Link href={url} target="_blank" rel="noopener noreferrer">
        <IconButton>
          <ExternalIcon />
        </IconButton>
      </Link>
    );
  };

  const getRenderCell = (field) => {
    switch (field) {
      case FIELDS.assistantId.id:
        return ({ row: { accountId, assistantId } }) => linkRenderCell(getLinkToAgent(accountId, assistantId));
      case FIELDS.pipelineLink.id:
        return ({ row: { pipelineLink } }) => linkRenderCell(pipelineLink);
      case FIELDS.ddLink.id:
        return ({ row: { ddLink } }) => linkRenderCell(ddLink);
      case FIELDS.type.id:
        return ({ row: { type } }) => capitalizeFirstLetter(type);
      case FIELDS.status.id:
        return ({ row: { status } }) => capitalizeFirstLetter(status);
      default:
        return null;
    }
  };

  const columns = Object.values(FIELDS).map((field) => ({
    field: field.id,
    headerName: field.headerName,
    enableFilter: field.enableFilter,
    valueGetter: field.valueGetter,
    width: field.width,
    renderCell: getRenderCell(field.id)
  }));

  return {
    columns,
    failures,
    isLoading
  };
}
